import { Box } from "@mui/material";
import React from "react";
import { Copyright, Footer, NavBar } from "../components";

const MainLayout = ({ children }) => {
  return (
    <>
      <NavBar />
      <Box sx={{ m: 0, p: 0, width: "100vw" }}>{children}</Box>

      {/* Website Footer */}
      <Footer />

      {/* Copyright section */}

      <Copyright />
    </>
  );
};

export default MainLayout;
